import axiosInstance from "../../../api/axiosInstance";

export const fetchPracticeSentences = async ({ page = 0, size = 20, search } = {}) => {
  try {
    const params = { page, size };
    if (search?.trim()) params.search = search.trim();
    const res = await axiosInstance.get("/public/vocabulary/practice-sentences", { params });
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message: err.response?.data?.message || "Failed to fetch practice sentences",
    };
  }
};
